export default __webpack_public_path__ + "static/media/mwoa2.d383e313.JPG";